import React from 'react';
import { ThankYouCard } from './components/ThankYouCard';
export function App() {
  return <main className="flex min-h-screen w-full items-center justify-center bg-ink-900 bg-[radial-gradient(ellipse_at_50%_0%,rgba(200,245,59,0.08)_0%,transparent_60%)] px-5 py-10 font-sans" data-id="element-0" data-mp="35ctrb58krzcj">
      <ThankYouCard data-id="element-1" data-mp="3fargbuy9e067" />
    </main>;
}